import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';
// export const customerGroup = 'tigerstaden';
export const customerGroup = 'carlsberg_sports_bar';

const supportEmail = {
	[customerGroup]: `${customerGroup}@smoothr.de`,
};
const firebaseConfig = {
	[customerGroup]: {
		apiKey: 'AIzaSyCr3lLGBJYcBKrOeiGFUUnvAK1V72CKzgU',
		authDomain: 'luca-6c304.firebaseapp.com',
		projectId: 'luca-6c304',
		storageBucket: 'luca-6c304.firebasestorage.app',
		messagingSenderId: '452572869469',
		appId: '1:452572869469:web:1ed60f10938f7c11d5aeb4',
	},
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyAUJ0yCbuGUs9lDKehj-VGlD0oeU3XO__A',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	countryList: ['de'],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup + '-dev',
	allergens_link: '',
	...apiEnvironment,
	hasRecommendations: true,
	hjid: 5035140,
	merchantId: '1110017883',
	merchantGoogleId: '123123123',
};
